<template>
  <a-spin :spinning="loading">
    <a-descriptions :column="3" style="margin-bottom: -15px">
      <a-descriptions-item :label="$t('business.label.orderNo')">
        <span class="normalFont">{{order.no}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.invoiceTime')">
        <span class="normalFont">{{order.invoiceTime}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.storer')">
        <span class="normalFont">{{order.storer.name}}</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.approvalAdviceOperator')">
        <a-input-search v-model="order.approvalAdvice.operator" readOnly @dblclick="()=>$refs.userModal.open()" @search="()=>$refs.userModal.open()"/>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('business.label.approvalAdviceContent')">
        <a-input v-model="order.approvalAdvice.content"/>
      </a-descriptions-item>
    </a-descriptions>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="details"
      :loading="loading"
      size="mini"
      :height="scrollY"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="lot.no" title="business.label.lotNo"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="90"/>
      <vxe-column field="location.no" title="business.label.locationNo"/>
      <vxe-column field="detail.inventoryState" title="business.label.inventoryState">
        <template #default="{row}">
          {{inventoryStates.find(item => item.ordinal === row.detail.inventoryState).name}}
        </template>
      </vxe-column>
      <vxe-column field="detail.quantity" title="title.unqualifiedQuantity"/>
      <vxe-column field="detail.reasons" title="business.label.reason"/>
    </vxe-table>
    <UserModal ref="userModal" @change="(rows)=>onUserChange(rows[0])"/>
  </a-spin>
</template>
<script>
import { findAll, findEnum, findOne, post } from '@/api/Api'
import { DisqualificationOrder } from '@/api/dto/order/DisqualificationOrder'
import { Advice } from '@/api/dto/valueobject/Advice'
import UserModal from '@/views/modal/UserModal.vue'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'DisqualificationConfirmDetail',
  components: { UserModal },
  data() {
    return {
      loading: false,
      order: new DisqualificationOrder(),
      details: [],
      inventoryStates: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.7675)// 表格竖向滚动条
    }
  },
  mounted() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStates = res.result
      }
    })
  },
  methods: {
    getData(record) {
      if (record) {
        this.order.no = record.order.no
      }
      if (this.order.no === null || this.order.no === undefined) {
        return this.$message.warning('请先选择单据')
      }
      this.loading = true
      findOne('disqualificationOrderFactory', { no: this.order.no }).then(res => {
        if (res.success) {
          if (res.result.approvalAdvice === null) {
            res.result.approvalAdvice = new Advice()
          }
          Object.assign(this.order, res.result)
          findAll('disqualificationDetailFactory', { no: this.order.no }).then(res => {
            if (res.success) {
              this.details = res.result
            }
          })
        }
      }).finally(() => this.loading = false)
    },
    clear() {
      this.order = new DisqualificationOrder()
      this.details = []
    },
    onUserChange(user) {
      if (user) {
        this.order.approvalAdvice.operator = user.name
      } else {
        this.order.approvalAdvice.operator = ''
      }
    },
    approve() {
      if (this.order.no === null || this.order.no === undefined) {
        this.$emit('failed')
        return this.$message.warning('请先选择单据')
      }
      let operator = this.order.approvalAdvice.operator
      if (operator === null || operator === undefined || operator === '') {
        this.$emit('failed')
        return this.$message.warning('审核人不能为空')
      }
      this.loading = true
      post(Api.conversionQualifierApprove, {}, this.order).then(res => {
        if (res.success) {
          this.$message.success('审核成功')
          this.$emit('success')
        } else {
          this.$emit('failed')
        }
      }).finally(() => this.loading = false)
    },
    reject() {
      if (this.order.no === null || this.order.no === undefined) {
        this.$emit('failed')
        return this.$message.warning('请先选择单据')
      }
      let operator = this.order.approvalAdvice.operator
      if (operator === null || operator === undefined || operator === '') {
        this.$emit('failed')
        return this.$message.warning('审核人不能为空')
      }
      this.loading = true
      post(Api.conversionQualifierReject, {}, this.order).then(res => {
        if (res.success) {
          this.$message.success('驳回成功')
          this.$emit('success')
        } else {
          this.$emit('failed')
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>
<style scoped>
.normalFont {
  font-weight: bold;
  color: #404040;
}
</style>